import Vue from 'vue'
import Field from '../models/field'
import ApiBase from '@/api/apiBase'
import moment from 'moment'


class ApiCourts {

  static all(callBack, errorCallBack){
    ApiBase.get(`/courts`,callBack,ApiCourts.parseAll,errorCallBack)
  }
  static parseAll(response){
    var result = []
    for(var i in response.data.data){
      result.push(Field.parse(response.data.data[i]))
    }
    return result
  }

  static find(courtID,callBack, errorCallBack){
    ApiBase.get(`/courts/${courtID}`,callBack,ApiCourts.parseFind,errorCallBack)
  }
  static parseFind(response){
    return Field.parse(response.data.data)
  }

  static create(court,callBack,errorCallBack){
    let data = {
        "name": court.name,
        "address": court.address,
        "lat": court.lat,
        "lng": court.lng,
        "city": court.city,
        "state": court.state,
        "country": court.country
    }
    ApiBase.post(`/courts`,data,callBack,ApiBase.noParse,errorCallBack)
  }

  static isAvailable(match,callBack,errorCallBack){
    let data = {
      date: moment(match.date).format('YYYY-MM-DDTHH:mmZ'),
      duration: match.duration
    }
    ApiBase.post(`/courts/${match.court.id}/is_available`,data,callBack,ApiBase.noParse,errorCallBack)
  }

  static areAvailable(matches,callBack,errorCallBack){
    let data = {
      matches:[]
    }

    for(var i in matches){
      let match = matches[i]
      data.matches.push({
        date: moment(match.date).format('YYYY-MM-DDTHH:mmZ'),
        duration: match.duration,
        court_id: match.court.id
      })
    }
    ApiBase.post(`/courts/are_available`,data,callBack,ApiBase.noParse,errorCallBack)
  }

  static update(court, callBack, errorCallBack){
    let data = {
        "name": court.name,
        "address": court.address,
        "lat": court.lat,
        "lng": court.lng,
        "city": court.city,
        "state": court.state,
        "country": court.country
    }

    ApiBase.put(`/courts/${court.id}`,data,callBack,ApiBase.noParse,errorCallBack)
  }

  static active(court, callBack, errorCallBack){
    let data = {
        "active": court.active ? false : true
    }

    ApiBase.put(`/courts/${court.id}`,data,callBack,ApiBase.noParse,errorCallBack)
  }



  static delete(court, callBack, errorCallBack){
    ApiBase.delete(`/courts/${court.id}`,callBack,ApiBase.noParse,errorCallBack)
  }

}

export default ApiCourts



// WEBPACK FOOTER //
// ./src/api/apiCourts.js